import React, { ChangeEvent } from 'react'
import styled from 'styled-components'
import selectOnFocus from '../../modules/autoselect'

type InputSize = 'small' | 'medium' | 'large';

interface CircleQtyInputWrapperProps {
    $inputSize?: InputSize;
    $primary?: boolean;
}

interface QtyInputProps {
    $inputSize?: InputSize;
}

const CircleQtyInputWrapper = styled.div<CircleQtyInputWrapperProps>`
    min-width: ${props => props.$inputSize === 'medium' ? '3em' : props.$inputSize === 'large' ? '4em' : props.$inputSize === 'small' ? '2.5em' : 'none'};
    min-height: ${props => props.$inputSize === 'medium' ? '3em' : props.$inputSize === 'large' ? '4em' : props.$inputSize === 'small' ? '2.5em' : 'none'};
    max-width: ${props => props.$inputSize === 'medium' ? '3em' : props.$inputSize === 'large' ? '4em' : props.$inputSize === 'small' ? '2.5em' : 'none'};
    max-height: ${props => props.$inputSize === 'medium' ? '3em' : props.$inputSize === 'large' ? '4em' : props.$inputSize === 'small' ? '2.5em' : 'none'};
    border-radius: 50%;
    background: ${props => props.$primary ? 'tomato' : '#afd0cd'};
    display: flex;
    justify-content: center;
    align-items: center;
`

const QtyInput = styled.input<QtyInputProps>`
    width: ${props => props.$inputSize === 'medium' ? '2.6em' : props.$inputSize === 'large' ? '3.6em' : props.$inputSize === 'small' ? '2em' : 'none'};
    height: ${props => props.$inputSize === 'medium' ? '2.6em' : props.$inputSize === 'large' ? '3.6em' : props.$inputSize === 'small' ? '2em' : 'none'};
    border-radius: 50%;
    border: none;
    appearance: none;
    --webkit-appearance: none;
    outline: none;
    text-align: center;
    background: #eff3f4;
    color: #838484;
`

interface CircleNumericInputProps {
    changeFunc: (value: number) => void;
    primary?: boolean;
    size?: InputSize;
    disabled?: boolean;
    value?: number;
    isAllowNegative?: boolean;
    step?: number;
    tabIndex?: number;
}

export default function CircleNumericInput({
    changeFunc,
    primary,
    size = 'medium',
    disabled = false,
    value = 0,
    isAllowNegative = false,
    step,
    tabIndex
}: CircleNumericInputProps) {
    const [inputValue, setInputValue] = React.useState<number | string>(value);

    const handleChangeProductQty = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        if ((value === '-' || value === '') && isAllowNegative) {
            setInputValue(value);
        } else {
            const numericValue = +value;
            if (!isNaN(numericValue)) {
                setInputValue(value);
                changeFunc(numericValue);
            }
        }
    }

    return (
        <CircleQtyInputWrapper
            $primary={primary}
            $inputSize={size}
        >
            <QtyInput
                value={isAllowNegative ? inputValue : value}
                type={'number'}
                onChange={handleChangeProductQty}
                min={isAllowNegative ? -100 : 0}
                onClick={selectOnFocus}
                $inputSize={size}
                disabled={disabled}
                step={step}
                onWheel={(e) => e.currentTarget.blur()}
                tabIndex={tabIndex}
            />
        </CircleQtyInputWrapper>
    )
}

